<template>
  <div class="tinymce-box fit">
    <editor ref="editor" v-model="myValue" :init="init" :disabled="disabled" @click="onClick"></editor>
    <a-modal class="modal-" destroy-on-close title="插入图片" :width="1000" v-model="showImgSelector" :body-style="{ padding: '15px 12px' }" @cancel="handleCancelUpload">
      <template slot="footer">
        <a-button key="back" @click="handleCancelUpload">取消</a-button>
        <a-button :disabled="!(this.imageForm.url && this.imageForm.url.startsWith('http'))" key="submit" type="primary" @click="handleImageSelect">确认插入</a-button>
      </template>
      <div class="flex">
        <div class="img-sources v-pr-sm v-mr-sm" style="width: 170px; border-right: 1px solid #e0e0e0">
          <!-- <div class="img-source">项目进展报告</div>
          <div class="img-source">本地上传</div>
          <div class="img-source">网络图片</div> -->
          <a-menu class="no-border" v-model="imgSources" @select="onImgSourceSelect">
            <a-menu-item key="1">
              <a-icon type="file-image" />
              <span>项目进展报告</span>
            </a-menu-item>
            <a-menu-item key="4">
              <a-icon type="file-image" />
              <span>财务报销票据</span>
            </a-menu-item>
            <a-menu-item key="2">
              <a-icon type="cloud-upload" />
              <span>本地上传</span>
            </a-menu-item>
            <a-menu-item key="3">
              <a-icon type="global" />
              <span>网络图片</span>
            </a-menu-item>
          </a-menu>
        </div>
        <div class="col" style="max-height: 500px; overflow: hidden; min-height: 220px">
          <vue-scroll
            class="col"
            :ops="{
              scrollPanel: {
                maxHeight: 500,
              },
            }"
            v-if="imgSources[0] == '1'"
          >
            <template v-if="imgReports.length > 0">
              <a-card class="img-report" :class="{ 'v-mt-md': index > 0 }" v-for="(item, index) in imgReports" :key="item.reportId" :body-style="{ padding: 0 }">
                <span slot="title">{{ item.reportName }}</span>
                <report-medias-selector :visible-formats="['image']" :project-id="projectId" :show-name="false" :medias="item.medias" @select="handleReportImageSelect" v-if="item.medias.length" />
              </a-card>
            </template>
            <div style="padding: 42px 24px; border: 1px solid #eee" v-else>
              <a-empty :image="emptyImage">
                <div slot="description">暂无数据</div>
              </a-empty>
            </div>
          </vue-scroll>
          <vue-scroll
            class="col"
            :ops="{
              scrollPanel: {
                maxHeight: 500,
              },
            }"
            v-else-if="imgSources[0] == '4'"
          >
            <template v-if="budgetsTreeData.length > 0">
              <div class="flex v-px-xs">
                <div style="width: 260px">
                  <a-directory-tree default-expand-all @select="onBudgetTreeSelect">
                    <a-icon slot="switcherIcon" type="down" />
                    <a-tree-node :title="item.name" v-for="(item, index) in budgetsTreeData" :key="index">
                      <template v-if="item.children && item.children.length">
                        <a-tree-node is-leaf :title="`${child.name}（${child.files ? child.files.length : 0}）`" v-for="(child, cindex) in item.children" :key="`${index}-${cindex}`" />
                      </template>
                    </a-tree-node>
                  </a-directory-tree>
                </div>
                <div class="col v-ml-sm">
                  <!-- <file-container :files="budgetTreeNode.files" fileSign="P01" :belongId="budgetTreeNode.projectId" v-if="budgetTreeNode && budgetTreeNode.files" /> -->
                  <div v-if="budgetTreeNode && budgetTreeNode.files && budgetTreeMedias.length">
                    <report-medias-selector :cols="3" :visible-formats="['image']" :project-id="projectId" :show-name="false" :medias="budgetTreeMedias" @select="handleReportImageSelect" />
                  </div>
                  <div style="padding: 42px 24px; border: 1px solid #eee" v-else>
                    <a-empty :image="emptyImage">
                      <div slot="description">暂无报销图片</div>
                    </a-empty>
                  </div>
                </div>
              </div>
            </template>
            <div style="padding: 42px 24px; border: 1px solid #eee" v-else>
              <a-empty :image="emptyImage">
                <div slot="description">暂无数据</div>
              </a-empty>
            </div>
          </vue-scroll>
          <div class="file-settings flex full-height overflow-hidden v-pr-lg overflow-hidden" style="height: 220px" v-else-if="imgSources[0] == '2'">
            <div class="file-settings-preview" style="width: 220px">
              <a-upload
                :action="`${baseURL}/file/upload`"
                :data="{
                  params: JSON.stringify(fileParams),
                }"
                :file-list="imageFiles"
                :before-upload="beforeUploadFile"
                @preview="handlePreviewFile"
                @change="info => handleUploadChange(info, 1, 'imageFiles')"
                list-type="picture-card"
                class="picture-uploader picture-uploader-editor overflow-hidden"
                accept=".png, .jpg, .jpeg, .gif"
                ref="imageFiles"
              >
                <div v-if="imageFiles.length === 0">
                  <a-icon type="cloud-upload" />
                  <div class="ant-upload-text">上传图片</div>
                </div>
              </a-upload>
            </div>
            <div class="file-settings-content col relative-position">
              <a-form-model ref="imageForm" :model="imageForm">
                <a-row :gutter="24">
                  <a-col :span="24">
                    <a-form-model-item prop="url">
                      <span slot="label">图片地址</span>
                      <a-input ref="imageUrl" disabled v-model="imageForm.url" placeholder="链接地址" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="24">
                    <a-form-model-item label="图片描述" prop="alt">
                      <a-input ref="imageAlt" v-model="imageForm.alt" placeholder="图片描述" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="宽" prop="width">
                      <a-input type="number" v-model="imageForm.width"></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="高" prop="height">
                      <a-input type="number" v-model="imageForm.height"></a-input>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </div>
          </div>
          <a-form-model class="v-px-lg" ref="imageForm" :model="imageForm" v-else-if="imgSources[0] == '3'">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item prop="url">
                  <span slot="label">
                    图片地址
                    <span class="text-red font-xs">（必填）</span>
                  </span>
                  <a-input ref="imageUrl" v-model="imageForm.url" placeholder="链接地址" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item label="图片描述" prop="alt">
                  <a-input ref="imageAlt" v-model="imageForm.alt" placeholder="图片描述" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="宽" prop="width">
                  <a-input type="number" v-model="imageForm.width"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="高" prop="height">
                  <a-input type="number" v-model="imageForm.height"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <!-- <div class="file-settings flex full-height overflow-hidden col" style="min-height: 300px">
          <div class="file-settings-preview" style="width: 260px">
            <a-upload
              :action="`${baseURL}/file/upload`"
              :data="{
                params: JSON.stringify(fileParams),
              }"
              :file-list="imageFiles"
              :before-upload="beforeUploadFile"
              @preview="handlePreviewFile"
              @change="info => handleUploadChange(info, 1, 'imageFiles')"
              list-type="picture-card"
              class="picture-uploader picture-uploader-raise overflow-hidden"
              accept=".png, .jpg, .jpeg, .gif"
              ref="imageFiles"
            >
              <div v-if="imageFiles.length === 0">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
          </div>
          <div class="file-settings-content col relative-position">
            <a-form-model ref="imageForm" :model="imageForm">
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-model-item prop="url">
                    <span slot="label">链接地址<span class="text-red font-xs">（必填）</span> </span>
                    <a-input ref="imageUrl" v-model="imageForm.url" placeholder="链接地址" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item label="图片描述" prop="alt">
                    <a-input ref="imageAlt" v-model="imageForm.alt" placeholder="图片描述" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="宽" prop="width">
                    <a-input type="number" v-model="imageForm.width"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="高" prop="height">
                    <a-input type="number" v-model="imageForm.height"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div> -->
      </div>
    </a-modal>
    <a-modal destroy-on-close centered title="插入视频" :width="700" v-model="showVideoSettings" :body-style="{ padding: '15px 20px' }" @cancel="handleCancelUpload">
      <template slot="footer">
        <a-button key="back" @click="handleCancelUpload">取消</a-button>
        <a-button :disabled="!imageForm.url" key="submit" type="primary" @click="handleVideoSelect">确认插入</a-button>
      </template>
      <div class="file-settings flex full-height">
        <div class="file-settings-preview" style="width: 260px">
          <div class="file-settings-preview__video">
            <a-upload-dragger
              :action="`${baseURL}/file/upload`"
              :data="{
                params: JSON.stringify(fileParams),
              }"
              :file-list="videoFiles"
              :before-upload="beforeUploadFile"
              @preview="handlePreviewFile"
              @change="info => handleUploadChange(info, 1, 'videoFiles')"
              class="picture-uploader-raise overflow-hidden"
              accept=".avi,.mp4,.mov,.mkv,.rm,.rmvb,.flv,.wmv"
              ref="videoFiles"
              v-if="!imageForm.url"
            >
              <div v-if="videoFiles.length === 0">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传视频</div>
              </div>
            </a-upload-dragger>
            <player :url="imageForm.url" :config="{ videoInit: true }" v-else />
          </div>
          <!-- <span class="v-mt-xs">图片预览</span> -->
        </div>
        <div class="file-settings-content col relative-position">
          <a-form-model ref="imageForm" :model="imageForm">
            <a-row :gutter="24">
              <!-- <a-col :span="24">
                <a-form-model-item prop="url">
                  <span slot="label">链接地址<span class="text-red font-xs">（必填）</span> </span>
                  <a-input ref="imageUrl" v-model="imageForm.url" placeholder="链接地址" />
                </a-form-model-item>
              </a-col> -->
              <a-col :span="24">
                <a-form-model-item label="视频描述" prop="alt">
                  <a-input ref="imageAlt" v-model="imageForm.alt" placeholder="视频描述" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="宽" prop="width">
                  <a-input type="number" v-model="imageForm.width"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="高" prop="height">
                  <a-input type="number" v-model="imageForm.height"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </div>
    </a-modal>
    <a-modal class="modal-finance" destroy-on-close title="插入财务数据" :width="1200" v-model="showFinance" :body-style="{ padding: '15px 12px' }" @cancel="showFinance = false">
      <template slot="footer">
        <a-button key="back" @click="showFinance = false">取消</a-button>
        <a-button key="submit" type="primary" @click="handleFinanceSelect">确认插入</a-button>
      </template>
      <div class="panel-info-section">
        <div class="panel-info-section-title flex items-center">
          <a-icon type="caret-right" class="text-primary v-mr-xs" />
          <span class="text-bold">项目预算明细表</span>
        </div>
        <div class="v-mb-sm">
          <a-checkbox-group v-model="budgetCols">
            <a-checkbox disabled value="index">序号</a-checkbox>
            <a-checkbox disabled value="name">费用名称</a-checkbox>
            <a-checkbox value="year">费用年份</a-checkbox>
            <a-checkbox value="price">单价</a-checkbox>
            <a-checkbox value="quantity">数量</a-checkbox>
            <a-checkbox value="amount">预算金额</a-checkbox>
            <a-checkbox value="applied">请款金额</a-checkbox>
            <a-checkbox value="expensed">实际支出金额</a-checkbox>
            <a-checkbox value="subtract">差额</a-checkbox>
            <a-checkbox value="remainApplied">请款余额</a-checkbox>
            <a-checkbox value="invoiceAmount">票据金额</a-checkbox>
            <!-- <a-checkbox value="invoiceFiles">票据文件</a-checkbox> -->
          </a-checkbox-group>
        </div>
        <a-table class="list-table" size="small" rowKey="uid" :loading="budgetLoading" :expanded-row-keys.sync="expandedBudgetKeys" :pagination="false" :data-source="budgets" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
          <a-table-column title="序号" data-index="index" :width="60" align="left">
            <template slot-scope="text, record">
              {{ record.no }}
            </template>
          </a-table-column>
          <a-table-column title="费用名称" data-index="name" :ellipsis="true" :width="280" align="left">
            <template slot-scope="text, record">
              <span :class="{ 'text-bold': record.sum }">{{ record.name || '-' }}</span>
            </template>
          </a-table-column>
          <a-table-column title="费用年份" data-index="year" :width="90" align="center" :ellipsis="true" v-if="budgetCols.includes(' data')">
            <template slot-scope="text, record">
              <template v-if="!record.isRoot">{{ record.year }}</template>
            </template>
          </a-table-column>
          <a-table-column title="单价" data-index="price" :width="110" align="right" :ellipsis="true" v-if="budgetCols.includes('price')">
            <template slot-scope="text, record">
              <template v-if="!record.isRoot">{{ record.price }}</template>
            </template>
          </a-table-column>
          <a-table-column title="数量" data-index="quantity" :width="90" align="right" v-if="budgetCols.includes('quantity')">
            <template slot-scope="text, record">
              <template v-if="!record.isRoot">{{ record.quantity }}</template>
            </template>
          </a-table-column>
          <a-table-column title="预算金额" data-index="amount" :width="110" align="right" v-if="budgetCols.includes('amount')">
            <template slot-scope="text, record">
              <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="请款金额" data-index="applied" :width="110" align="right" v-if="budgetCols.includes('applied')">
            <template slot-scope="text, record">
              <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.applied) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="实际支出金额" data-index="expensed" :width="110" align="right" v-if="budgetCols.includes('expensed')">
            <template slot-scope="text, record">
              <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.expensed) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="差额" data-index="subtract" :width="110" align="right" v-if="budgetCols.includes('subtract')">
            <template slot-scope="text, record">
              <span :class="{ 'text-green': record.amount - record.expensed > 0, 'text-bold': record.sum }">{{ $utils.thousands(record.amount - record.expensed) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="请款余额" data-index="remainApplied" :width="110" align="right" v-if="budgetCols.includes('remainApplied')">
            <template slot-scope="text, record">
              <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.remainApplied) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="票据金额" data-index="invoiceAmount" :width="110" align="right" v-if="budgetCols.includes('invoiceAmount')">
            <template slot-scope="text, record">
              <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.expensed) }}</span>
            </template>
          </a-table-column>
          <a-table-column title="票据文件" data-index="invoiceFiles" :width="330" align="left" v-if="budgetCols.includes('invoiceFiles')">
            <template slot-scope="text, record">
              <file-container v-if="record.files" :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01"></file-container>
              <template slot-scope="text, record" v-else-if="record.name == '合计'">
                <span>
                  <b class="text-primary">{{ record.fileTotal }}</b>
                  张发票
                </span>
              </template>
            </template>
          </a-table-column>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { convertBudgetsRecords } from '@/utils/data'
import { getBudgetsWithAmount } from '@/api/project/common'
import ReportMediasSelector from '@/views/common/report-medias-selector'
import { listReport } from '@/api/project/common'
import { mapActions } from 'vuex'
import Player from '@/components/player'
// 文档 http://tinymce.ax-z.cn/
// 引入组件
import tinymce from 'tinymce/tinymce' // tinymce默认hidden，不引入不显示
import Editor from '@tinymce/tinymce-vue'

// 引入富文本编辑器主题的js和css
// import 'tinymce/skins/content/default/content.css'
import 'tinymce/themes/silver/theme.min.js'
import 'tinymce/icons/default/icons' // 解决了icons.js 报错Unexpected token '<'

// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import 'tinymce/plugins/image' // 插入上传图片插件
import 'tinymce/plugins/media' // 插入视频插件
import 'tinymce/plugins/table' // 插入表格插件
import 'tinymce/plugins/lists' // 列表插件
import 'tinymce/plugins/advlist' // 列表插件
import 'tinymce/plugins/wordcount' // 字数统计插件
import 'tinymce/plugins/link'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/code'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/help'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/textpattern'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/directionality'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/autosave'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/importword'
import 'tinymce/plugins/quickbars'

const textStyle = "font-family: '微软雅黑','sans-serif';mso-bidi-font-size:10.5pt;font-size:10.5pt;line-height: 20px;"

export default {
  components: {
    Editor,
    Player,
    ReportMediasSelector,
  },
  name: 'Tinymce',
  props: {
    // 默认的富文本内容
    value: {
      type: String,
      default: '',
    },
    minHeight: {
      type: Number,
      default: 300,
    },
    projectId: {
      type: Number,
      required: true,
    },
    fileParams: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
    // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
    baseUrl: {
      type: String,
      default: window.location.origin ? window.location.origin : '',
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      // default: 'link lists image code table wordcount media preview fullscreen autoresize help',
      default:
        'quickbars print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave bdmap indent2em formatpainter importword',
    },
    toolbar: {
      type: [String, Array],
      default:
        'code undo redo | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent lineheight |\
        styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | imgSelector finance | \
        table charmap emoticons hr pagebreak insertdatetime print | bdmap indent2em formatpainter | importword preview fullscreen',
      // default:
      //   'formatselect | fontselect | fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | undo redo | link unlink code lists table imgSelector videoSelector | removeformat | fullscreen preview',
    },
  },
  data() {
    let vm = this
    return {
      init: {
        language_url: './tinymce/langs/zh_CN.js',
        // language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
        language: 'zh_CN',
        skin_url: './tinymce/skins/ui/oxide',
        // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
        // skin_url: 'tinymce/skins/ui/oxide-dark', // 暗色系
        convert_urls: false,
        height: 600,
        min_height: vm.minHeight,
        // content_css（为编辑区指定css文件）,加上就不显示字数统计了
        // content_css: `${this.baseUrl}tinymce/skins/content/default/content.css`,
        // （指定需加载的插件）
        // inline: true,
        plugins: this.plugins,
        // readonly: true,
        toolbar: this.toolbar, // （自定义工具栏）
        // toolbar_sticky: true,
        toolbar_drawer: false,
        autosave_interval: '15s',
        quickbars_selection_toolbar: 'bold italic forecolor backcolor underline | link blockquote imgSelector',
        quickbars_insert_toolbar: 'imgSelector',
        content_style: 'h1,h2,h3,h4,h5,h6 { margin-bottom: .65em;margin-top: 0; } p {margin-top: 0;margin-bottom:1em;} img { max-width: 100%}',
        setup: function (editor) {
          editor.on('init', function (ed) {
            // ed.target.editorCommands.execCommand('fontName', false, '微软雅黑')
            // ed.target.editorCommands.execCommand("fontSize", false, '14px')
            this.getBody().style.fontSize = '14px'
            // this.getBody().style.color = '#843FA1';
            this.getBody().style.fontFamily = '微软雅黑'
          })
          // 注册一个自定义的按钮
          editor.ui.registry.addButton('imgSelector', {
            icon: 'image',
            onAction: () => {
              vm.materialType = 1
              // vm.showMaterialLib = true
              vm.imageForm = {
                url: '',
                alt: '',
                width: undefined,
                height: undefined,
              }
              vm.imgSources = ['1']
              vm.imgSource = '1'
              vm.showImgSelector = true
            },
          })
          editor.ui.registry.addButton('videoSelector', {
            icon: 'embed',
            onAction: () => {
              vm.materialType = 3
              // vm.showMaterialLib = true
              vm.showVideoSettings = true
            },
          })
          editor.ui.registry.addButton('finance', {
            icon: 'table',
            onAction: () => {
              vm.showFinance = true
              vm.loadBudgets()
            },
          })
        },
        statusbar: true, // 底部的状态栏
        menubar: true,
        // menubar: 'file edit view format table tools', // （1级菜单）最上方的菜单
        branding: false, // （隐藏右下角技术支持）水印“Powered by TinyMCE”
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        font_formats:
          '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          // let form = new FormData()
          // form.append('file', blobInfo.blob(), blobInfo.filename())
          // this.uploadFile(form).then((data) => {
          //   success(`${this.fileBaseURL}/file/${data.id}`)
          // })
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          success(img)
        },
      },
      imgSource: '1',
      imgSources: ['1'],
      imgReports: [],
      imgLoading: false,
      showMaterialLib: false,
      showImgSelector: false,
      showImageSettings: false,
      showVideoSettings: false,
      showFinance: false,
      imageForm: {
        url: '',
        alt: '',
        width: undefined,
        height: undefined,
      },
      imageFiles: [],
      videoFiles: [],
      budgetLoading: false,
      budgetCols: ['index', 'name', 'year', 'price', 'quantity', 'amount', 'applied', 'expensed', 'subtract', 'remainApplied', 'invoiceAmount'],
      expandedBudgetKeys: [],
      budgets: [],
      budgetsTreeData: [],
      budgetTreeNode: {},
      budgetTreeMedias: [],
      materialType: 1,
      myValue: this.value,
      selectedFile: null,
    }
  },
  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    },
    imgSource() {
      this.imageForm.url = ''
      if (this.imgSource == '1') {
        this.loadImgReports()
      } else if (this.imgSource == '4') {
        this.loadBudgets()
      }
    },
  },
  methods: {
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick(e) {
      this.$emit('onClick', e, tinymce)
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = ''
    },
    onImageSelect(file, fileClassify) {
      this.imageForm.url = `${this.fileBaseURL}/file/${file.fileId}`
      this.selectedFile = file
      if (fileClassify === 1) {
        this.showImageSettings = true
      } else {
        this.showVideoSettings = true
      }
    },
    handleReportImageSelect(item) {
      let { baseURL, projectId } = this
      this.imageForm.url = `${baseURL}/file/img?id=${item.fileId}&belongId=${projectId}&fileSign=P01`
      // this.handleImageSelect()
    },
    loadBudgets() {
      this.budgetLoading = true
      getBudgetsWithAmount(this.projectId).then(({ data }) => {
        if (data.success) {
          let { manageRate, records, raisedAmount } = data.result
          let { tableRecords } = convertBudgetsRecords(records, { showManageAmount: true, raisedAmount, manageRate })
          this.budgets = tableRecords
          this.budgetsTreeData = tableRecords.filter(d => !d.sum)
          this.expandedBudgetKeys = tableRecords.filter(d => d.children && d.children.length).map(d => d.uid)
        }
        this.budgetLoading = false
      })
    },
    handleImageSelect() {
      this.showImgSelector = false
      this.showMaterialLib = false
      // this.$refs.editor.editor.insertContent(
      //   '<svg width="24" height="24"><path d="M5 15.7l3.3-3.2c.3-.3.7-.3 1 0L12 15l4.1-4c.3-.4.8-.4 1 0l2 1.9V5H5v10.7zM5 18V19h3l2.8-2.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 0 1-1-1V4c0-.6.4-1 1-1zm6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill-rule="nonzero"></path></svg>'
      // )
      let { url, alt, width, height } = this.imageForm
      let html = []
      html.push(`<p><img src="${url}" `)
      if (alt) {
        html.push(` alt="${alt}"`)
      }
      // if (width) {
      //   html.push(` width="${width}"`)
      // }
      if (width) {
        html.push(` width="${width}px" `)
      } else {
        html.push(' style="max-width: 100%" ')
      }
      // html.push(` width="${width ? width + 'px' : '100%'}"`)
      if (height) {
        html.push(` height="${height}"`)
      }
      html.push('/></p>')
      this.$refs.editor.editor.insertContent(html.join(''))
    },
    handleVideoSelect() {
      this.showVideoSettings = false
      this.showMaterialLib = false
      // let { url } = this.imageForm
      let { url, alt, width, height } = this.imageForm
      let html = []
      html.push(`<p><video mediatype="video" controls="controls" src="${url}" `)
      if (alt) {
        html.push(` alt="${alt}"`)
      }
      if (width) {
        html.push(` width="${width}px" `)
      } else {
        html.push(' style="max-width: 100%" ')
      }
      html.push(` height="${height || 400}"`)
      html.push('/></p>')
      this.$refs.editor.editor.insertContent(html.join(''))
      // this.$refs.editor.editor.insertContent(`<QPlayer fileId="${this.selectedFile.fileId}"></QPlayer>`)
      // this.$refs.editor.editor.insertContent(`<video class="" tabindex="2" mediatype="video" src="${url}"></video>`)
      // this.$refs.editor.editor.insertContent(`<div id="qp-${this.selectedFile.fileId}"></div>`)
    },
    handleCancelUpload() {
      this.showImgSelector = false
      this.showVideoSettings = false
      this.imageForm.url = ''
      this.imageFiles = []
      this.videoFiles = []
    },
    handleUploadChange(info, count, ref) {
      let { baseURL, projectId } = this
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
        let { status } = info.file
        if (status === 'done') {
          let { fileId, fileSign } = this[ref][0]
          this.imageForm.url = `${baseURL}/file/view?id=${fileId}&belongId=${projectId}&fileSign=${fileSign}`
        }
      }
    },
    onImgSourceSelect({ item, key, selectedKeys }) {
      this.imgSources = [...selectedKeys]
      this.imgSource = selectedKeys[0]
    },
    loadImgReports() {
      let params = {
        projectId: this.projectId,
        pageSize: -1,
        state: 9,
        fileFormat: 'image',
      }
      this.imgLoading = true
      listReport(params).then(({ data }) => {
        if (data.success) {
          let { records } = data.result
          records.forEach(record => {
            let { medias } = record
            let effectMedias = []
            let opinionMedias = []
            let sceneMedias = []
            let memoMedias = []
            let activityMedias = []
            medias.forEach(item => {
              item.uid = Math.random()
              item.files = item.file ? [item.file] : []
              item.isChoice = !!item.isChoice
              if (item.mediaType == 1) {
                effectMedias.push(item)
              } else if (item.mediaType == 2) {
                opinionMedias.push(item)
              } else if (item.mediaType == 3) {
                sceneMedias.push(item)
              } else if (item.mediaType == 4) {
                memoMedias.push(item)
              } else if (item.mediaType == 5) {
                activityMedias.push(item)
              }
            })
            record.effectFiles = effectMedias.filter(m => m.isChoice && m.file && ['jpg', 'jpeg', 'png', 'gif'].includes(m.file.fileFormat))
            record.opinionFiles = opinionMedias.filter(m => m.isChoice && m.file && ['jpg', 'jpeg', 'png', 'gif'].includes(m.file.fileFormat))
            record.sceneFiles = sceneMedias.filter(m => m.isChoice && m.file && ['jpg', 'jpeg', 'png', 'gif'].includes(m.file.fileFormat))
            record.memoFiles = memoMedias.filter(m => m.isChoice && m.file && ['jpg', 'jpeg', 'png', 'gif'].includes(m.file.fileFormat))
            record.activityFiles = activityMedias.filter(m => m.isChoice && m.file && ['jpg', 'jpeg', 'png', 'gif'].includes(m.file.fileFormat))
          })
          this.imgReports = records
        }
        this.imgLoading = false
      })
    },
    onBudgetTreeSelect(keys) {
      let ids = keys[0].split('-')
      this.budgetTreeNode = this.budgetsTreeData[+ids[0]].children[+ids[1]]
      this.budgetTreeMedias = this.budgetTreeNode.files.map(file => ({ fileId: file.fileId, file }))
    },
    creatBudgetTableRow(record, cols, indent = '') {
      let html = []
      html.push(`<tr><td><span style="${textStyle}">${record.no || ''}</span></td><td><span style="${textStyle}">${indent + (record.sum ? '<strong>' + record.name + '</strong>' : record.name)}</span></td>`)
      cols.forEach(col => {
        if (col == 'year') {
          html.push(`<td><span style="${textStyle}">${record.year || ''}</span></td>`)
        } else if (col == 'price') {
          html.push(`<td><span style="${textStyle}">${record.price || ''}</span></td>`)
        } else if (col == 'quantity') {
          html.push(`<td><span style="${textStyle}">${record.quantity || ''}</span></td>`)
        } else if (col == 'amount') {
          html.push(`<td style="text-align: right;"><span style="${textStyle}">${record.sum ? '<strong>' + this.$utils.thousandsIfNull(record.amount, '') + '</strong>' : this.$utils.thousands(record.amount)}</span></td>`)
        } else if (col == 'applied') {
          html.push(`<td style="text-align: right;"><span style="${textStyle}">${record.sum ? '<strong>' + this.$utils.thousandsIfNull(record.applied, '') + '</strong>' : this.$utils.thousands(record.applied)}</span></td>`)
        } else if (col == 'expensed') {
          html.push(`<td style="text-align: right;"><span style="${textStyle}">${record.sum ? '<strong>' + this.$utils.thousandsIfNull(record.expensed, '') + '</strong>' : this.$utils.thousands(record.expensed)}</span></td>`)
        } else if (col == 'subtract') {
          html.push(`<td style="text-align: right;"><span style="${textStyle}">${record.sum ? '<strong>' + this.$utils.thousandsIfNull(record.amount - record.expensed, '') + '</strong>' : this.$utils.thousands(record.amount - record.expensed)}</span></td>`)
        } else if (col == 'remainApplied') {
          html.push(`<td style="text-align: right;"><span style="${textStyle}">${record.sum ? '<strong>' + this.$utils.thousandsIfNull(record.remainApplied, '') + '</strong>' : this.$utils.thousands(record.remainApplied)}</span></td>`)
        } else if (col == 'invoiceAmount') {
          html.push(`<td style="text-align: right;"><span style="${textStyle}">${record.sum ? '<strong>' + this.$utils.thousandsIfNull(record.expensed, '') + '</strong>' : this.$utils.thousands(record.expensed)}</span></td>`)
        }
      })
      html.push('</tr>')
      if (record.children && record.children.length) {
        record.children.forEach(item => {
          html.push(this.creatBudgetTableRow(item, cols, indent + '&nbsp;&nbsp;'))
        })
      }
      return html.join('')
    },
    handleFinanceSelect() {
      let { budgets, budgetCols } = this
      let html = []
      if (budgets.length) {
        html.push(`<table style="border-collapse: collapse; width: 100%; font-family: '微软雅黑','sans-serif';" border="1"><tr><th><span style="${textStyle}">序号</span></th><th><span style="${textStyle}">费用名称</span></th>`)
        budgetCols.forEach(col => {
          if (col == 'year') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">年份</span></th>`)
          } else if (col == 'price') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">单价</span></th>`)
          } else if (col == 'quantity') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">数量</span></th>`)
          } else if (col == 'amount') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">预算金额</span></th>`)
          } else if (col == 'applied') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">请款金额</span></th>`)
          } else if (col == 'expensed') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">实际支出金额</span></th>`)
          } else if (col == 'subtract') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">差额</span></th>`)
          } else if (col == 'remainApplied') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">请款余额</span></th>`)
          } else if (col == 'invoiceAmount') {
            html.push(`<th style="text-align: center;"><span style="${textStyle}">票据金额</span></th>`)
          }
        })
        html.push('</tr>')
        budgets.forEach(record => {
          html.push(this.creatBudgetTableRow(record, budgetCols, ''))
        })
        html.push('</table>')
      }
      this.$refs.editor.editor.insertContent(html.join(''))
      this.showFinance = false
    },
    refresh(report) {
      let { type, year, month, quarter } = report
      console.log(type, year, month, quarter)
      let reportName = '总结报告'
      let reportType = ''
      if (type == 2) {
        reportName = `${year || 'xxxx'}年${quarter ? '一二三四'.charAt(quarter - 1) : 'x'}季度总结报告`
        reportType = '季度项目报告'
      } else if (type == 5) {
        reportName = `${year || 'xxxx'}年年度总结报告`
        reportType = '年度项目报告'
      } else if (type == 6) {
        reportName = '项目总结报告'
        reportType = '项目总结报告'
      }
      let doc = this.$refs.editor.editor.getWin().document
      doc.querySelector('.reportName').innerHTML = reportName
      doc.querySelector('.reportType').innerHTML = reportType
    },
  },
  created() {
    this.init = Object.assign(this.init, this.options)
  },
  mounted() {
    this.loadImgReports()
    // tinymce.init({})
  },
}
</script>
